import { device } from '@/utils/index'

const content = [
    // 第一章 Evaluation
    // 小标题
    {
        key: 'section9.0',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "Evaluation", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book2/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    // 模板样式 单个带边框
    {
        key: 'section9.1',
        type: 'template',
        category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
        templateType: true, // true英语最后一个模块
        templateStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 38, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#5CA683', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // marginTop: 30,
            // marginBottom: 30,
            padding: 0,
            marginTop: 98,
            marginBottom: 30,
            backgroundColor: '#FFFFFF',
            // paddingTop: 0,
            // paddingBottom: 0,
            borderRadius: 0,
            // border: '',
            // borderTop: '',
            // borderBottom: ''
        },
        content: [
            {
                key: 'section9.1.1',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'I',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 28, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    }
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section9.1.1.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section9.1.1.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Rate your performance according to the sheet below.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                fontSize: 28, // 文字大小  默认：20
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 5,
                    marginBottom: 0,
                    paddingLeft: 20,
                    paddingRight: 20,

                }
            },
            // 列表
            {
                key: 'section9.1.2',
                type: "title",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "Knowledge Objectives", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 30, // 行高  默认：46
                    maxWidth: 500,
                    // marginLeft: 20,
                    // paddingLeft: 20,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    margin: 24,
                    marginBottom: 30,
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },
            // 模板样式 单个带边框
            {
                key: 'section9.1.3',
                type: 'template',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                showReset: 2, // 1展示重置按钮 2展示五角星按钮
                rateValue:null,
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#F0F8F5',
                    marginTop: -60,
                    padding: 34,
                    paddingTop: 44,
                    borderRadius: 10,
                    border: 'none',
                    borderTop: 'none',
                    borderBottom: 'none'
                },
                content: [
                    // 列表
                    {
                        key: 'section9.1.3.1', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        contentType: 'position',
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.3.1.1', // *必填* 唯一标识
                                type: 'text',
                                text: 'master the new words and expressions'
                            },
                            {
                                key: 'section9.1.3.1.2', // *必填* 唯一标识
                                type: 'positionList',
                                content: [
                                    {
                                        key: 'section9.1.3.1.2.1',
                                        type: 'position',
                                        text: 'Listening and Speaking',
                                        guideChapter: 'chapter1sub2',
                                        guide: 'section1.6.2',
                                    },
                                    {
                                        key: 'section9.1.3.1.2.2',
                                        type: 'position',
                                        text: 'Text A',
                                        guideChapter: 'chapter1sub3',
                                        guide: 'section3.1.1.1.12',
                                    },
                                    {
                                        key: 'section9.1.3.1.2.3',
                                        type: 'position',
                                        text: 'Text B',
                                        isLock: 1,
                                        // guideChapter: 'chapter1sub3',
                                        // guide: 'section3.1',
                                    }
                                ]
                            }
                        ],
                    },
                    // 列表
                    {
                        key: 'section9.1.3.2', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        contentType: 'position',
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.3.2.1', // *必填* 唯一标识
                                type: 'text',
                                text: 'master '
                            },
                            {
                                key: 'section9.1.3.2.2', // *必填* 唯一标识
                                type: 'position',
                                text: 'the translation skills',
                                guideChapter: 'chapter1sub4',
                                guide: 'section4.0',
                            },
                            {
                                key: 'section9.1.3.2.3', // *必填* 唯一标识
                                type: 'text',
                                text: ' of festival names'
                            },
                        ],
                    },
                    // 列表
                    {
                        key: 'section9.1.3.3', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        contentType: 'position',
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.3.3.1', // *必填* 唯一标识
                                type: 'text',
                                text: 'know '
                            },
                            {
                                key: 'section9.1.3.3.2', // *必填* 唯一标识
                                type: 'position',
                                text: 'the steps of writing a poster',
                                guideChapter: 'chapter1sub5',
                                guide: 'section5',
                            },
                            {
                                key: 'section9.1.3.3.3', // *必填* 唯一标识
                                type: 'text',
                                text: ' for a festival party'
                            },
                        ],
                    },
                    // 列表
                    {
                        key: 'section9.1.3.4', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        contentType: 'position',
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.3.4.1', // *必填* 唯一标识
                                type: 'text',
                                text: 'know '
                            },
                            {
                                key: 'section9.1.3.4.2', // *必填* 唯一标识
                                type: 'position',
                                text: 'the steps of writing a WeChat article',
                                guideChapter: 'chapter1sub7',
                                guide: 'section7',
                            },
                            {
                                key: 'section9.1.3.4.3', // *必填* 唯一标识
                                type: 'text',
                                text: ' about traditional Chinese festivals'
                            },
                        ],
                    },
                ],
            },
            // 列表
            {
                key: 'section9.1.4',
                type: "title",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "Skill Objectives", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 30, // 行高  默认：46
                    maxWidth: 500,
                    // marginLeft: 20,
                    // paddingLeft: 20,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    margin: 24,
                    marginBottom: 30,
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },
            // 模板样式 单个带边框
            {
                key: 'section9.1.5',
                type: 'template',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                showReset: 2, //1展示重置按钮 2展示五角星按钮
                rateValue:null,
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#F0F8F5',
                    marginTop: -60,
                    // marginBottom: 30,
                    padding: 34,
                    paddingTop:44,
                    // paddingBottom: 0,
                    borderRadius: 10,
                    border: 'none',
                    borderTop: 'none',
                    borderBottom: 'none'
                },
                content: [
                    {
                        key: 'section9.1.5.1', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.5.1.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.5.1.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'talk about the impact of traditional Chinese festivals on the Chinese community and the world with others',
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    {
                        key: 'section9.1.5.2', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.5.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.5.2.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'introduce traditional Chinese festivals to others',
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    // 列表
                    {
                        key: 'section9.1.5.3', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.5.3.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.5.3.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'apply translation skills to translating festival  names indepen', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    {
                        key: 'section9.1.5.4', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.5.4.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.5.4.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'write a poster for a festival party', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    {
                        key: 'section9.1.5.5', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.5.5.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.5.5.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'organize team-building activities to celebrate  festivals', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                ],
            },
            // 列表
            {
                key: 'section9.1.6',
                type: "title",
                category: 8, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
                text: "Quality Objectives", // *必填* 标题文本内容
                titleImageType: 3,
                // titleImage: require("@/assets/images/books/book2/title-icon2.png"),
                textStyle: {
                    fontFamily: 'Arial', // 字体，本地配置的字体
                    fontSize: 26, // 文字大小  默认：26
                    height: 49,
                    width: 'auto',
                    lineHeight: 30, // 行高  默认：46
                    maxWidth: 500,
                    // marginLeft: 20,
                    // paddingLeft: 20,
                    // textIndent: 30, // 首行缩进 标题前带图标的写30，不带图标的写20
                    // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    color: '#fff', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#5CA683', // 背景颜色  默认：无
                    margin: 24,
                    marginBottom: 30,
                    // positionImage: require("@/assets/images/books/book2/title-icon1.png"), // 背景图片  默认：无
                    borderRadius: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 0
                    }
                },
            },
            // 模板样式 单个带边框
            {
                key: 'section9.1.7',
                type: 'template',
                category: 1, // *必填* 分类 1：单个带边框 2：两级tabs 3：可收起模块
                showReset: 2, //1展示重置按钮 2展示五角星按钮
                rateValue:null,
                templateStyle: {
                    // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
                    // fontSize: 38, // 文字大小  默认：26
                    // lineHeight: 40, // 行高  默认：46
                    // textIndent: 55, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#5CA683', // 文本颜色  默认：#00a8ac
                    backgroundColor: '#F0F8F5',
                    marginTop: -60,
                    // marginBottom: 30,
                    padding: 34,
                    paddingTop:44,
                    // paddingBottom: 0,
                    borderRadius: 10,
                    border: 'none',
                    borderTop: 'none',
                    borderBottom: 'none',
                    marginBottom:25
                },
                content: [
                    {
                        key: 'section9.1.7.1', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.7.1.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.7.1.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'share the importance of inheriting and spreading traditional Chinese festival culture with others',
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    {
                        key: 'section9.1.7.2', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.7.2.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.7.2.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'enhance my awareness of national pride by discussing traditional Chinese festivals',
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                    // 列表
                    {
                        key: 'section9.1.7.3', // *必填* 唯一标识
                        type: 'list', // *必填* 类型：视频
                        templateType: 1, // *必填* 板式 1：ul
                        content: [ // *必填* 列表内容
                            {
                                key: 'section9.1.7.3.1', // *必填* 唯一标识
                                type: 'text', // *必填* 类型：正文
                                isInTable: true,
                                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                                    {
                                        key: 'section9.1.7.3.1.1', // *必填* 唯一标识
                                        category: 'text', // *必填* 内容类型 text：文本
                                        text: 'tell the significance of the Spring Festival to the Chinese people and its global impact in my own words', // *必填* 文本内容
                                        textStyle: {
                                            fontFamily: 'Calibri', // 字体，本地配置的字体
                                        },
                                    },
                                ],
                                textStyle: {
                                    fontSize: device.isMobile ? 28 : 24,
                                    lineHeight: 40,
                                    color: '#333', // 文本颜色  默认：#00a8ac                                                                                            
                                },
                            },
                        ],
                    },
                ],
            },
            {
                key: 'section9.1.8',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 55,
                    height: 40,
                    text: 'II',
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: 28, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'center', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#fff', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 15,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    }
                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section9.1.8.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section9.1.8.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Rate your performance according to the sheet below.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'ArialMT', // 字体，本地配置的字体
                                fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
                                fontSize: 28, // 文字大小  默认：20
                            },
                        }
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        // fontSize: 20, // 文字大小  默认：20
                        // lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 5,
                    marginBottom: 0,
                    paddingLeft: 20,
                    paddingRight: 20,

                }
            },
            {
                key: 'section9.1.9',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 35,
                    height: 40,
                    text: '1.',
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 10,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section9.1.9.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section9.1.9.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Reflect on your learning experience in this unit and write a short paragraph to discuss one thing you have learned and how it has impacted you.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                     
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 30,
                    paddingRight: 20,
                }
            },
            {
                key: 'section9.1.10',
                type: 'paragraph',
                category: 'withBefore',
                leftMark: { // 左侧标记
                    type: 'block', // block: 左侧占满 inline：仅第一行有缩进
                    width: 35,
                    height: 40,
                    text: '2.',
                    textStyle: {
                        fontFamily: 'Calibri', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        textAlign: 'right', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#5CA683', // 背景颜色  默认：无
                        // backgroundImage: require("@/assets/images/books/book2/title-mark-icon.png"),
                        paddingLeft: 0,
                        paddingRight: 10,
                        marginLeft: 0,
                        marginRight: 14,
                        marginTop: 0,
                        marginBottom: 0,
                        top: 0,
                        left: 0,
                    },

                },
                content: { //右侧文本内容，目前只有一段文字
                    key: 'section9.1.10.1', // *必填* 唯一标识
                    type: 'text', // *必填* 类型：正文
                    isInTable: true,
                    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                        {
                            key: 'section9.1.10.1.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'Set one goal for yourself to improve your English skills in the next unit. Explain why this goal is important to you.', // *必填* 文本内容
                            textStyle: {
                                fontFamily: 'Calibri', // 字体，本地配置的字体

                            },
                        },
                     
                    ],
                    textStyle: {
                        // fontFamily: 'xxx', // 字体，本地配置的字体
                        fontSize: device.isMobile ? 28 : 24, // 文字大小  默认：20
                        lineHeight: 40, // 行高  默认：36
                        // textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                        color: '#333', // 文本颜色  默认：#00a8ac
                        // backgroundColor: '#FFF', // 背景颜色  默认：无
                    },
                },
                // 段落内外间距
                paragraphStyle: {
                    marginTop: 0,
                    marginBottom: 10,
                    padding: 0,
                    paddingLeft: 30,
                    paddingRight: 20,
                }
            },
        ],
    },
]

export default content